import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

const PARAM = { tab: 'status', search: 'q' } as const;

function withParam(current: URLSearchParams, key: string, value: string | null) {
  const next = new URLSearchParams(current);
  if (value) next.set(key, value);
  else next.delete(key);
  return next;
}

/** Writes replace the history entry, so typing does not stack up Back-button steps. */
export function useListFilterParams<T extends string>(tabs: readonly T[], defaultTab: T) {
  const [params, setParams] = useSearchParams();
  const rawTab = params.get(PARAM.tab);
  const tab = tabs.find((t) => t === rawTab) ?? defaultTab;
  const search = params.get(PARAM.search) ?? '';

  const setTab = useCallback(
    (next: T) =>
      setParams((current) => withParam(current, PARAM.tab, next === defaultTab ? null : next), {
        replace: true,
      }),
    [setParams, defaultTab],
  );

  const setSearch = useCallback(
    (next: string) =>
      setParams((current) => withParam(current, PARAM.search, next), { replace: true }),
    [setParams],
  );

  return { tab, setTab, search, setSearch };
}
